import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  padding: 1rem 0.4rem;
  color: ${(props) => props.theme.colors.contactInfo.title};
  border-radius: 1rem;
  box-sizing: border-box;

  ${breakpoint("tablet")`
    padding: 1em 0 0 1em;

    ${({ paddingLess }) =>
      paddingLess &&
      css`
        padding: 0;
      `}
  `}
`

export const Split = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;

  ${({ withBottomMargin }) =>
    withBottomMargin &&
    css`
      margin-bottom: 2rem;

      ${breakpoint("tablet")`
        margin-bottom: 3.1rem;
      `}
    `}

  ${({ withBottomMargin }) =>
    !withBottomMargin &&
    css`
      ${breakpoint("tablet")`
        margin-bottom: 1rem;
      `}
    `}
`

export const A = styled.a`
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
`

export const Title = styled.span`
  display: block;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
`

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.6rem;
  margin: 0.5em 0 0.8em;
  max-width: 1200px;

  > svg {
    width: 1.2rem;
    color: #aaa;
  }

  ${({ spacer }) =>
    !!spacer &&
    css`
      margin-bottom: 1.2em;
    `}

  ${({ bio }) =>
    !!bio &&
    css`
      margin: 0;
    `}
`

export const Info = styled.div`
  ${breakpoint("tablet")`
    max-width: unset;
  `}
`

export const BioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1rem;
  margin-top: 1.2rem;
  width: 100%;

  ${breakpoint("tablet")`
    flex-direction: row;
    margin-top: 0;
  `}
`

export const Photo = styled.img`
  width: 76px;
  height: 76px;
  border-radius: 20rem;

  ${breakpoint("tablet")`
    width: 132px;
    height: 132px;
    margin-right: 8px;
  `}
`
